﻿angular.module('configure.configurationModule', [])
.constant('data_project_constants',
{
    'api_authentication_scopes': {
        'data_query': 'data:query',
        'user_edit': 'user:edit',
        'user_add': 'user:add',
        'user_remove': 'user:remove'
    },
    'session_management': {
        'number_of_connection_retries': 3,
        'session_restore_interval': 2000,
        'session_toast_visible_timespan': 6000
    },
    'session_events': {
        'session_start': 'sessionManagementFactory:start',
        'session_warning': 'sessionManagementFactory:warning',
        'session_end': 'sessionManagementFactory:end'
    },
    'session_event_times': {
        // 13:30 minutes until we show the session warning
        'session_warn': 13.5 * (60 * 1000),
        'session_modal_count_down': 1 * (60 * 1000),
        'session_refresh_delay': 1 * (60 * 1000),
        // 14:30 minutes then we end the session for the user
        // the reason for this is that the refresh token on the auth server
        // has an idle timeout of 15 minutes so this gives us a buffer of 
        // 30 seconds so that we don't get into the trouble of having the 
        // auth time out before the UI times out
        'session_end': 14.5 * (60 * 1000)
    },
    'cookies': {
        'csrf_name': 'CSRF-TOKEN',
        'user_name': 'DpAdminAuthorization',
        'user_is_professor_name': 'UserRole-Professor',
        'okta_storage_key': 'okta-token-storage'
    },
    'oktaConfig': {
        'clientId': 'okta_client_id',
        'issuerUrl': 'okta_issuer_url',
        'redirectUrl': 'okta_redirect_url'
    },
    'endpoints': {
        'application_api': 'api_application_endpoint',
        'reference_api': 'reference_api_application_endpoint',
        'award_api': 'award_api_application_endpoint'
    }
});



//////////////////
// WEBPACK FOOTER
// ./source/angular/app/constants.js
// module id = 62
// module chunks = 0